import {
  CompanyModel,
  plainToInstanceCompany,
} from '@/entities/company/model/CompanyModel';
import { CompaniesService } from '@/shared/api/service';

export class CompanyApi {
  static async getCompany(companyId: number): Promise<CompanyModel> {
    const response = await CompaniesService.v1CompaniesRetrieve({ companyId });
    return plainToInstanceCompany(response);
  }
}
